// extracted by mini-css-extract-plugin
module.exports = {"icon":"SocialLinksBanner_icon___0_LU","copy":"SocialLinksBanner_copy__d8PvY"};